import { onMounted, onUnmounted, readonly, ref, type Ref } from "vue"

const DESKTOP_BREAKPOINT = 768

export function useKeyboardInset(): {
  keyboardInset: Readonly<Ref<number>>
  viewportHeight: Readonly<Ref<number>>
} {
  const keyboardInset = ref(0)
  const viewportHeight = ref(window.innerHeight)

  function update(): void {
    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      keyboardInset.value = 0
      viewportHeight.value = window.innerHeight
      return
    }
    const vv = window.visualViewport
    if (!vv) {
      keyboardInset.value = 0
      viewportHeight.value = window.innerHeight
      return
    }
    keyboardInset.value = Math.max(0, window.innerHeight - vv.height - vv.offsetTop)
    viewportHeight.value = vv.height
  }

  onMounted(() => {
    update()
    window.visualViewport?.addEventListener("resize", update)
    window.visualViewport?.addEventListener("scroll", update)
  })

  onUnmounted(() => {
    window.visualViewport?.removeEventListener("resize", update)
    window.visualViewport?.removeEventListener("scroll", update)
  })

  return { keyboardInset: readonly(keyboardInset), viewportHeight: readonly(viewportHeight) }
}
